<template>
  <!-- start 弹窗外层 -->
  <div class="dialog-box" v-if="open">
    <!-- start 登录弹窗 -->
    <div class="login-popup">
      <!-- start 登录弹窗头部 -->
      <div class="login-popup-header">
        <img
          class="login-popup-header-img"
          src="@/assets/images/time-expired-popup-header.png"
        />
        <div class="login-popup-header-content">
          <div class="login-popup-header-info">
            <img src="@/assets/images/xiao-header-icon.png" />
            <span>创建打字员</span>
          </div>
          <div class="closed-container" @click="close">
            <img
              class="login-popup-header-info-img"
              src="@/assets/images/white-close-icon.png"
            />
          </div>
        </div>
      </div>
      <!-- end 登录弹窗头部 -->
      <!-- start 登录弹窗内容 -->
      <div class="login-popup-content">
        <div class="login-popup-content-tab">
          <div
            class="default-tab"
            :class="loginType == 'create' ? 'select-tab' : ''"
            @click="
              (loginType = 'create'),
                (userInfoForm = {
                  nickname: null,
                  ageGrades: null,
                  computerLevel: null,
                }),
                (selectLoginKey = null)
            "
          >
            创建一个昵称
          </div>
          <div
            class="default-tab"
            :class="loginType == 'select' ? 'select-tab' : ''"
            style="margin-left: 60px"
            @click="loginType = 'select'"
          >
            选择现有昵称
          </div>
        </div>
        <template v-if="loginType == 'create'">
          <div class="options-list" style="margin-top: 16px">
            <div class="options-list-label">
              <span v-if="isNicknameNull" class="not-null">昵称不能为空</span>
              <span v-if="isNicknameRepetition" class="not-null"
                >昵称不能重复</span
              >
            </div>
            <input
              class="nickname"
              v-model="userInfoForm.nickname"
              :disabled="loginType != 'create'"
              placeholder="请输入昵称"
              maxlength="10"
            />
          </div>
          <div class="options-list" style="margin-top: 10px">
            <div
              class="options-list-label"
              style="
                font-size: 14px;
                font-weight: bold;
                color: #526070;
                margin-bottom: 6px;
              "
            >
              为了给您更准确地匹配练习课程，请填写如下信息
            </div>
            <div class="options-list-label">
              您的年龄阶段
              <span v-if="isAgeGradesNull" class="not-null"
                >年龄阶段不能为空</span
              >
            </div>
            <CustomOptions
              style="margin-top: 10px"
              :optionList="ageGradesOptions"
              :value.sync="userInfoForm.ageGrades"
              :disabled="loginType != 'create'"
              placeholder="请选择年龄阶段"
            ></CustomOptions>
          </div>
          <div class="options-list" style="margin-top: 10px">
            <div class="options-list-label">
              您的电脑水平
              <span v-if="isComputerLevelNull" class="not-null"
                >电脑水平不能为空</span
              >
            </div>
            <CustomOptions
              style="margin-top: 10px"
              :optionList="computerLevelOptions"
              :value.sync="userInfoForm.computerLevel"
              :disabled="loginType != 'create'"
              placeholder="请选择电脑水平"
            ></CustomOptions>
          </div>
        </template>
        <template v-if="loginType == 'select'">
          <div class="options-list" style="margin-top: 16px">
            <div class="user-vessel">
              <div
                class="options-list"
                :class="selectLoginKey == key ? 'select-options-list' : ''"
                v-for="(item, key) in loginUserList"
                :key="key"
                @click="selectLoginUser(item, key)"
                @mouseover="selectKey(key)"
                @mouseleave="index = null"
              >
                <div>{{ item.nickname }}</div>
                <img
                  style=" width: 13px; height: 14px;"
                  class="delete-icon"
                  src="@/assets/images/delete-icon.png"
                  v-if="index == key && item.nickname != loginNickname"
                  @click.stop="del(key)"
                />
              </div>
            </div>
          </div>
        </template>
        <div class="login-btn" @click="loginFun">进入</div>
      </div>
      <!-- end 登录弹窗内容 -->
    </div>
    <!-- end 登录弹窗 -->
  </div>
  <!-- end 弹窗外层 -->
</template>

<script>
import CustomOptions from "./CustomOptions.vue";
export default {
  name: "TimeExpiredPopup",
  components: {
    CustomOptions,
  },
  data() {
    return {
      // 选中用户
      index: null,
      // 用户信息
      userInfoForm: {
        nickname: null,
        ageGrades: null,
        computerLevel: null,
      },
      // 年龄阶段
      ageGradesOptions: [
        {
          label: "10岁以下",
        },
        {
          label: "10-20岁",
        },
        {
          label: "20-30岁",
        },
        {
          label: "30岁以上",
        },
      ],
      // 电脑水平
      computerLevelOptions: [
        {
          label: "新人入门",
        },
        {
          label: "刚接触电脑",
        },
        {
          label: "有一定电脑水平",
        },
        {
          label: "想提高打字速度",
        },
      ],
      // 昵称是否为空
      isNicknameNull: false,
      // 年龄是否为空
      isAgeGradesNull: false,
      // 电脑水平为空
      isComputerLevelNull: false,
      // 登录用户
      loginUserList: [],
      // 登录状态
      isLogin: false,
      //登录类型
      loginType: "create",
      // 昵称重复
      isNicknameRepetition: false,
      // 标记为
      sign: true,
      // 登录用户昵称
      loginNickname: null,
      // 选择用户坐标
      selectLoginKey: null,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loginType: {
      handler() {
        if (this.sign) {
          this.sign = false;
          return;
        }
        this.userInfoForm = {
          nickname: null,
          ageGrades: null,
          computerLevel: null,
        };
      },
    },
    open: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.onloadUser();
          this.onloadLoginDataList();
        }
      },
    },
  },
  created() {
    // 记载登录数据
    //this.onloadUser();
    // 加载登录用户列表
    //this.onloadLoginDataList();
  },
  methods: {
    // 删除登录用户
    del(key) {
      this.loginUserList.splice(key, 1);
      localStorage.setItem("loginDataList", JSON.stringify(this.loginUserList));
    },
    // 移入用户坐标
    selectKey(key) {
      this.index = key;
    },
    // 关闭弹窗
    close() {
      this.sign = true;
      this.$emit("close");
    },
    // 记载登录用户数据
    onloadUser() {
      let loginUser = localStorage.getItem("loginData");
      if (loginUser != null && loginUser != "null") {
        this.userInfoForm = JSON.parse(loginUser);
        this.loginNickname = this.userInfoForm.nickname;
        this.isLogin = true;
        this.loginType = "select";
      }
    },
    // 加载登录数据用户列表
    onloadLoginDataList() {
      let loginUserList = localStorage.getItem("loginDataList");
      if (loginUserList != null) {
        this.loginUserList = JSON.parse(loginUserList);
      }
    },
    // 选择登录用户
    selectLoginUser(obj, key) {
      this.loginType = "select";
      this.selectLoginKey = key;
      setTimeout(() => {
        this.userInfoForm = obj;
        this.loginFun();
      }, 200);
    },
    // 判断是否存在该用户
    existUser(arr, nickname) {
      let count = 0;
      arr.forEach((item) => {
        if (item.nickname == nickname) {
          count++;
        }
      });
      return count == 1;
    },
    // 登录
    loginFun() {
      let that = this;
      if (this.userInfoForm.nickname == null) {
        this.isNicknameNull = true;
        setTimeout(function () {
          that.isNicknameNull = false;
        }, 1000);
        return;
      }
      if (
        this.existUser(this.loginUserList, this.userInfoForm.nickname) &&
        this.loginType == "create"
      ) {
        this.isNicknameRepetition = true;
        setTimeout(function () {
          that.isNicknameRepetition = false;
        }, 1000);
        return;
      }
      if (this.userInfoForm.ageGrades == null) {
        this.isAgeGradesNull = true;
        setTimeout(function () {
          that.isAgeGradesNull = false;
        }, 1000);
        return;
      }
      if (this.userInfoForm.computerLevel == null) {
        this.isComputerLevelNull = true;
        setTimeout(function () {
          that.isComputerLevelNull = false;
        }, 1000);
        return;
      }
      this.loginUserList.push(this.userInfoForm);
      this.loginApi(
        this.userInfoForm.nickname,
        this.userInfoForm.ageGrades,
        this.userInfoForm.computerLevel
      );
      this.$emit("onloadUser");
      localStorage.setItem("loginData", JSON.stringify(this.userInfoForm));
      if (this.loginType == "create") {
        localStorage.setItem(
          "loginDataList",
          JSON.stringify(this.loginUserList)
        );
      }
      this.onloadLoginDataList();
      this.close();
    },
    // 登录
    loginApi(nickname, ageGrades, computerLevel) {
      let data = {
        fname: "typing_pass_win",
        data: nickname + "|" + ageGrades + "|" + computerLevel,
      };
      this.$http({
        url: "https://api.kuaixunda.cn/api/infoWrite",
        method: "post",
        params: data,
      }).then(({ data }) => {
        console.log(data);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .login-popup {
    width: 460px;
    height: 400px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #edf5fd;
    border: 1px solid #6090c0;
    border-radius: 2px 2px 2px 2px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;
    .login-popup-header {
      width: 100%;
      height: 38px;
      position: relative;
      .login-popup-header-img {
        width: 100%;
        height: 100%;
      }
      .login-popup-header-content {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 14px;
        box-sizing: border-box;
        align-items: center;
        .login-popup-header-info {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            margin-left: 6px;
            color: #ffffff;
            font-weight: 400;
            font-size: 14px;
          }
        }
        .closed-container {
          width: 40px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .login-popup-header-info-img {
            width: 14px;
            height: 14px;
          }
        }
        .closed-container:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
    }
    .login-popup-content {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .login-popup-content-tab {
        display: flex;
        margin-top: 16px;
        .default-tab {
          width: 84px;
          height: 24px;
          cursor: pointer;

          font-size: 14px;
          font-weight: 400;
          color: #526070;
          line-height: 24px;
        }
        .select-tab {
          color: #3ca5e2;
          font-weight: bold;
          color: #3ca5e2;
          border-bottom: 2px solid #40aae5;
          box-sizing: border-box;
        }
      }
      .user-vessel {
        margin-top: 10px;
        width: 400px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #c3cbd1;
        background: #ffffff;
        height: 120px;
        overflow-y: scroll;
        .options-list {
          width: 100%;
          padding: 6px 14px;
          box-sizing: border-box;
          font-size: 14px;
          font-weight: 400;
          color: #526070;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .delete-icon {
            width: 13px;
            height: 14px;
          }
        }
        .options-list:hover {
          background: #e9f1fa;
        }
        .select-options-list {
          background: #e9f1fa;
        }
      }
      .options-list {
        .options-list-label {
          color: #526070;
          font-weight: 400;
          font-size: 14px;
        }
        .nickname {
          margin-top: 10px;
          width: 400px;
          height: 34px;
          border: 1px solid #c3cbd1;
          border-radius: 2px 2px 2px 2px;
          background: #ffffff;
          outline: none;
          padding: 8px 10px;
          box-sizing: border-box;
          color: #526070;
          font-weight: 400;
          font-size: 14px;
          line-height: 34px;
        }
        // input::-webkit-input-placeholder {
        //   line-height: 39px;
        // }
      }
    }
  }
  .login-btn {
    margin-top: 19px;
    width: 122px;
    height: 34px;
    background: linear-gradient(180deg, #a1de67 0%, #61be43 100%);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #b9e68c;
    text-align: center;
    line-height: 34px;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    position: absolute;
    bottom: 24px;
  }
  .not-null {
    color: red;
    margin-left: 16px;
    font-size: 12px;
  }
}
</style>
